module.exports = __webpack_public_path__ + "static/foe_news_2-3ca4e80e4e2e36a71d7100e08fbaf255.jpg";